export const suitcase = {
  name: "suitcase" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M8.1 5c0-1.05.85-1.9 1.9-1.9h4c1.05 0 1.9.85 1.9 1.9v2.1H20c1.05 0 1.9.85 1.9 1.9v9.5a1.9 1.9 0 0 1-1.9 1.9H4a1.9 1.9 0 0 1-1.9-1.9V9c0-1.05.85-1.9 1.9-1.9h4.1V5Zm1.8 2.1h4.2V5a.1.1 0 0 0-.1-.1h-4a.1.1 0 0 0-.1.1v2.1ZM4 8.9a.1.1 0 0 0-.1.1v9.5a.1.1 0 0 0 .1.1h1.1V11a.9.9 0 1 1 1.8 0v7.6h10.2V11a.9.9 0 1 1 1.8 0v7.6H20a.1.1 0 0 0 .1-.1V9a.1.1 0 0 0-.1-.1H4Z" clip-rule="evenodd"/></svg>`,
  keywords: ["suitcase"],
  category: "other" as const,
};
